module.exports = __webpack_public_path__ + "media/images/icons/apple-touch-icon-ad22dc102c9a789ccb1f358c266f1f23.png";